<template>
	<div
		v-if="message"
		class="information"
		:class="{
			'information--disabled': disabled
		}"
		data-cy="information"
	>
		<helio-icon
			:data-anchor="`anchor-${_uid}`"
			class="information__icon"
			:color="color"
			:token="icon"
			:weight="iconWeight"
			@mouseover.native="showInformation = true"
			@mouseleave.native="showInformation = false"
		/>

		<helio-tooltip
			v-if="!disabled"
			ref="information"
			class="information__tooltip"
			:active="showInformation"
			:anchor="`anchor-${_uid}`"
			:gap="gap"
			position="top"
			:skin="skin"
		>
			<template v-slot:content>
				{{ message }}
			</template>
		</helio-tooltip>
	</div>
</template>

<script>
import Icon from '../icon/Icon.vue';
import Tooltip from '../tooltip/Tooltip.vue';

export default {
	name: 'Information',

	components: {
		'helio-icon': Icon,
		'helio-tooltip': Tooltip,
	},

	props: {
		color: {
			type: String,
			required: false,
			default: null,
			description: 'Sets the colour of the Information icon',
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Sets whether the Information component will be disabled for the user',
		},

		gap: {
			type: Number,
			required: false,
			default: 12,
			description: 'Sets the distance between the Information and its anchor element',
		},

		icon: {
			type: String,
			required: false,
			default: 'question-circle',
			description: 'Sets which FontAwesome or custom Centiva Icon will be used in the Information component',
		},

		iconWeight: {
			type: String,
			required: false,
			default: 'bold',
			validator: value => [
				'bold',
				'brand',
				'light',
				'regular',
			].indexOf(value) !== -1,
			description: 'Sets the weight of the icon',
		},

		message: {
			type: String,
			required: true,
			description: 'Sets the text that will appear in the Information component\'s tooltip',
		},

		skin: {
			type: String,
			required: false,
			default: 'light',
			validator: value => [
				'dark',
				'light',
			].indexOf(value) !== -1,
			description: 'Sets whether the Tooltip will have a dark or light skin',
		},
	},

	data() {
		return {
			showInformation: false,
		};
	},
};
</script>

<style lang="scss" src="./information.scss" />
